import angular from 'angular';

function TruncateFilter() {
	return function (s, len = 25) {
		// len should be at least 13, default is 25
		len = len < 13 ? 13 : len;
		// ['s' truncated to 'len' with space for tail]...[last 7 chars]
		return s && s.length > len ?
			s.slice(0, len - 9) + '&hellip;' + s.slice(-7, s.length) : s;
	};
}

export default angular.module('filters.truncate', [])
	.filter('truncate', TruncateFilter)
	.name;



// WEBPACK FOOTER //
// ./project/filters/truncate.js